import React from 'react'
import { useDispatch } from 'hooks/use-redux'
import { useNavigate } from 'react-router-dom'
import DocumentHeadTags from 'components/document-head-tags'
import Alert from 'components/ui/alert'
import Heading from 'components/ui/heading'
import ModalWindow from 'components/ui/modal-window'
import Spinner from 'components/ui/spinner'
import Stack from 'components/ui/stack'
type Props = {
  loading?: boolean
  error?: string | null | undefined
}

const ManageNestingModalLoader = ({
  loading,
  error,
}: Props): React.ReactNode => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const onClose = () => navigate('/')

  return (
    <>
      <DocumentHeadTags title="Manage nesting | DISCO" />
      <ModalWindow
        header={<Heading>Manage nesting</Heading>}
        isOpen
        onClose={onClose}
        width="large"
      >
        <Stack space="xsmall">
          {loading && <Spinner />}
          {error && (
            <Alert status="danger" icon="warning">
              {String(error)}
            </Alert>
          )}
        </Stack>
      </ModalWindow>
    </>
  )
}

export default ManageNestingModalLoader
